export default __webpack_public_path__ + "static/media/noDataPearAssess.7f29d142.svg";